import { render, staticRenderFns } from "./chart-component.vue?vue&type=template&id=5b74cb75&"
import script from "./chart-component.vue?vue&type=script&lang=js&"
export * from "./chart-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports